import { NgModule } from "@angular/core";
import { UIRouterModule } from "@uirouter/angular";
import { GetTokenStateDeclaration, TokenStateDeclaration } from "./token.stateconfig";

@NgModule({
    imports: [
        UIRouterModule.forChild({
            states: [
               GetTokenStateDeclaration,
               TokenStateDeclaration
            ]
        })
    ],
})

export class TokenModule {}
